import Prism from "prism-react-renderer/prism";

(typeof global !== "undefined" ? global : window).Prism = Prism;

// import the languages you want to support if not included in the default list
// require("prismjs/components/prism-csharp");